// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

const SwiperGalleries = function () {

    //galeria webdoor
    const gallerySwiperWebdoor = () => {

        if($("#swiperFull").find('img').length <= 1) return;

        // init Swiper:
        const swiper = new Swiper('#swiperFull', {
            speed       : 2000,
            loop        : true,
            effect      : 'slide',
            autoplay    : {
                delay: 5000,
                disableOnInteraction: false,
              },
            pagination  : {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                  return '<span class="' + className + '">' + (index + 1) + "</span>";
                },
              },
        });
    }

    // projeto
    const galleryProject = () => {

        const galproject = ".swiper-projeto";
        if($(galproject).length <= 0) return;

        // for( let i=0; i< $(galproject).length; i++ ) {
        $(galproject).each(function(e) {

            let _parent = $(galproject).eq(e).closest('.row-gallery');

            $(galproject).eq(e).addClass('swiper-container-projeto-' + e);
            _parent.find('.swiper-button-prev').addClass('swiper-button-prev-projeto-' + e);
            _parent.find('.swiper-button-next').addClass('swiper-button-next-projeto-' + e);

            if(screen.width > 992) {
                _parent.find('.swiper-pagination').addClass('swiper-pagination-projeto-' + e);
            } else {
                _parent.find('.swiper-pagination').addClass('swiper-pagination-projeto-mob-' + e);
            }

            /* if($('.swiper-container-projeto-' + e).find('picture').length <= 1) {
                $('.swiper-container-projeto-' + e).closest('.row-gallery').find('.wrap-navigation-sw').hide();
            } */

            const swiperprojeto = new Swiper('.swiper-container-projeto-' + e, {
                // cssMode     : true,
                speed       : 1500,
                loop        : true,
                effect      : 'slide',
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                normalizeSlideIndex: false,
                spaceBetween: '8.33333333%',//'8.33333333%',
                autoplay    : false,
                pagination  : {
                    el: screen.width > 992 ? '.swiper-pagination-projeto-' + e : '#pag-project',
                    type :  'custom',
                    renderCustom: function (swiper, current, total) {
                        return '<span class="swiper-pagination-current-custom"> <strong class="me-1">'+current + ' </strong> </span> /' + total;
                    }
                    /* clickable: true,
                    renderBullet: function (projeto, className) {
                    return '<span class="' + className + '">' + (projeto + 1) + "</span>";
                    }, */
                },
                navigation: {
                    prevEl: '.swiper-button-prev-projeto-' + e,
                    nextEl: '.swiper-button-next-projeto-' + e,
                },
                breakpoints : {
                    768: {
                        slidesPerView: "auto",
                      },
                }
            });
            swiperprojeto.on('slideChangeTransitionEnd', function(sw){
                // console.log(swiperprojeto.activeIndex, sw);
                let imgZoom     = $(galproject).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-zoom');
                let textDinamic = $(galproject).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-to-text');
                let titleDinamic = $(galproject).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-to-title');

                // ativa menu de nav
                const galTypeCurrent = $(galproject).eq(e).find('.swiper-slide-active').attr('data-img-gal');
                _parent.find('.nav-type-gallery a').removeClass('actived');
                _parent.find('.nav-type-gallery a[data-gal='+galTypeCurrent+']').addClass('actived');

                //mobile change text
                /* const textDropMob = $('.nav-type-gallery a[data-gal='+galTypeCurrent+']').first().text(); 
                _parent.find('.dropdown-toggle').text('');
                _parent.find('.dropdown-toggle').text( textDropMob ); */

                
                if(imgZoom)
                    _parent.find('.js-load-img-zoom').attr('href', imgZoom);

                if(textDinamic)
                    _parent.find('.js-dinamic-text').html(textDinamic);

                if(titleDinamic)
                    _parent.find('.js-dinamic-title').html(titleDinamic);

            });            

        })
    }

    //galeria diferenciais
    const galleryDiferenciais = () => {

        const galDiferenciais = ".swiper-diferenciais";
        if($(galDiferenciais).length <= 0) return;

        // for( let i=0; i< $(galDiferenciais).length; i++ ) {
        $(galDiferenciais).each(function(e) {

            let _parent = $(galDiferenciais).eq(e).closest('.row-gallery');

            $(galDiferenciais).eq(e).addClass('swiper-container-diferenciais-' + e);
            _parent.find('.swiper-button-prev').addClass('swiper-button-prev-diferenciais-' + e);
            _parent.find('.swiper-button-next').addClass('swiper-button-next-diferenciais-' + e);
            _parent.find('.swiper-pagination').addClass('swiper-pagination-diferenciais-' + e);

            if($('.swiper-container-diferenciais-' + e).find('picture').length <= 1) {
                $('.swiper-container-diferenciais-' + e).closest('.row-gallery').find('.wrap-navigation-sw').hide();
            }

            const swiperdiferenciais = new Swiper('.swiper-container-diferenciais-' + e, {
                // cssMode     : true,
                speed       : 1500,
                loop        : false,
                effect      : 'slide',
                autoplay    : false,
                pagination  : {
                    el: '.swiper-pagination-diferenciais-' + e,
                    type : 'custom',
                    renderCustom: function (swiper, current, total) {
                        return '<span class="swiper-pagination-current-custom">'+current + '</span> | ' + total;
                    }
                    /* clickable: true,
                    renderBullet: function (diferenciais, className) {
                    return '<span class="' + className + '">' + (diferenciais + 1) + "</span>";
                    }, */
                },
                navigation: {
                    prevEl: '.swiper-button-prev-diferenciais-' + e,
                    nextEl: '.swiper-button-next-diferenciais-' + e,
                },
            });
            swiperdiferenciais.on('slideChangeTransitionEnd', function(sw){
                // console.log(swiperdiferenciais.activeIndex, sw);
                let imgZoom     = $(galDiferenciais).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-zoom');
                let textDinamic = $(galDiferenciais).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-to-text');
                let titleDinamic = $(galDiferenciais).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-to-title');

                // ativa menu de nav
                const galTypeCurrent = $(galDiferenciais).eq(e).find('.swiper-slide-active').attr('data-img-gal');
                _parent.find('.nav-type-gallery a').removeClass('actived');
                _parent.find('.nav-type-gallery a[data-gal='+galTypeCurrent+']').addClass('actived');

                //mobile change text
                const textDropMob = $('.nav-type-gallery a[data-gal='+galTypeCurrent+']').first().text(); 
                _parent.find('.dropdown-toggle').text('');
                _parent.find('.dropdown-toggle').text( textDropMob );

                
                if(imgZoom)
                    _parent.find('.js-load-img-zoom').attr('href', imgZoom);

                if(textDinamic)
                    _parent.find('.js-dinamic-text').html(textDinamic);

                if(titleDinamic)
                    _parent.find('.js-dinamic-title').html(titleDinamic);

            });            

            function getSlideIndexByClass(className) {
                var index = 0;
                $.each($(galDiferenciais).find('.swiper-wrapper').children(), function(i, item) {
                    if ($(item).hasClass(className)) {
                    index = i;
                    return false;
                    }
                });
                return index;
            }

            //navigation
            $(document).on('click', '.nav-type-gallery a', function(e){
                e.preventDefault();
                const _thisGalGo            = $(this);
                const typeGallery           = _thisGalGo.attr('data-gal');
    
                $('.nav-type-gallery a').removeClass('actived');
                _thisGalGo.addClass('actived');
                
                swiperdiferenciais.slideTo(getSlideIndexByClass('data-img-gal--'+typeGallery));
                
            })

        })
    }

    // Localizacao
    const galleryLocation = () => {

        const gallocalization = ".swiper-localizacao";
        if($(gallocalization).length <= 0) return;

        // for( let i=0; i< $(gallocalization).length; i++ ) {
        $(gallocalization).each(function(e) {

            let _parent = $(gallocalization).eq(e).closest('.row-gallery');

            $(gallocalization).eq(e).addClass('swiper-container-localizacao-' + e);
            _parent.find('.swiper-button-prev').addClass('swiper-button-prev-localizacao-' + e);
            _parent.find('.swiper-button-next').addClass('swiper-button-next-localizacao-' + e);

            if(screen.width > 992) {
                _parent.find('.swiper-pagination').addClass('swiper-pagination-localizacao-' + e);
            } else {
                _parent.find('.swiper-pagination').addClass('swiper-pagination-localizacao-mob-' + e);
            }

            /* if($('.swiper-container-localizacao-' + e).find('picture').length <= 1) {
                $('.swiper-container-localizacao-' + e).closest('.row-gallery').find('.wrap-navigation-sw').hide();
            } */

            const swiperlocalizacao = new Swiper('.swiper-container-localizacao-' + e, {
                // cssMode     : true,
                speed       : 1500,
                loop        : true,
                effect      : 'slide',
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                normalizeSlideIndex: false,
                spaceBetween: '8.33333333%',//'8.33333333%',
                autoplay    : false,
                pagination  : {
                    el: screen.width > 992 ? '.swiper-pagination-localizacao-' + e : '#pag-local',
                    type : 'custom',
                    renderCustom: function (swiper, current, total) {
                        return '<span class="swiper-pagination-current-custom"> <strong class="me-1">'+current + ' </strong> </span> /' + total;
                    }
                    /* clickable: true,
                    renderBullet: function (localizacao, className) {
                    return '<span class="' + className + '">' + (localizacao + 1) + "</span>";
                    }, */
                },
                navigation: {
                    prevEl: '.swiper-button-prev-localizacao-' + e,
                    nextEl: '.swiper-button-next-localizacao-' + e,
                },
                breakpoints : {
                    768: {
                        slidesPerView: "auto",
                      },
                }
            });
            swiperlocalizacao.on('slideChangeTransitionEnd', function(sw){
                // console.log(swiperlocalizacao.activeIndex, sw);
                let imgZoom     = $(gallocalization).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-zoom');
                let textDinamic = $(gallocalization).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-to-text');
                let titleDinamic = $(gallocalization).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-to-title');

                // ativa menu de nav
                const galTypeCurrent = $(gallocalization).eq(e).find('.swiper-slide-active').attr('data-img-gal');
                _parent.find('.nav-type-gallery a').removeClass('actived');
                _parent.find('.nav-type-gallery a[data-gal='+galTypeCurrent+']').addClass('actived');

                //mobile change text
                /* const textDropMob = $('.nav-type-gallery a[data-gal='+galTypeCurrent+']').first().text(); 
                _parent.find('.dropdown-toggle').text('');
                _parent.find('.dropdown-toggle').text( textDropMob ); */

                
                if(imgZoom)
                    _parent.find('.js-load-img-zoom').attr('href', imgZoom);

                if(textDinamic)
                    _parent.find('.js-dinamic-text').html(textDinamic);

                if(titleDinamic)
                    _parent.find('.js-dinamic-title').html(titleDinamic);

            });            

        })
    }




    //galeria vertical predio
    const galleryPadrao = () => {

        const galPadrao = ".swiper-padrao";
        

        // for( let i=0; i< $(galPadrao).length; i++ ) {
        $(galPadrao).each(function(e) {
            
            const _tGal = $(this);
            //if(_tGal.find('picture').length <= 1) return;


            let _parent = _tGal.closest('.row-gallery');

            _tGal.addClass('swiper-container-padrao-' + e);
            _parent.find('.swiper-button-prev').addClass('swiper-button-prev-padrao-' + e);
            _parent.find('.swiper-button-next').addClass('swiper-button-next-padrao-' + e);
            _parent.find('.swiper-pagination').addClass('swiper-pagination-padrao-' + e);

            if($('.swiper-container-padrao-' + e).find('picture').length <= 1) {
                $('.swiper-container-padrao-' + e).closest('.row-gallery').find('.wrap-navigation-sw').hide();
            }

            const swiperPadrao = new Swiper('.swiper-container-padrao-' + e, {
                // cssMode     : true,
                speed       : 1500,
                loop        : true,
                effect      : 'slide',
                autoplay    : false,
                pagination  : {
                    el: '.swiper-pagination-padrao-' + e,
                    clickable: true,
                    /* type : 'custom',
                    renderCustom: function (swiper, current, total) {
                        return '<span class="swiper-pagination-current-custom">'+current + '</span> | ' + total;
                    } */
                    /* clickable: true,
                    renderBullet: function (padrao, className) {
                    return '<span class="' + className + '">' + (padrao + 1) + "</span>";
                    }, */
                },
                navigation: {
                    prevEl: '.swiper-button-prev-padrao-' + e,
                    nextEl: '.swiper-button-next-padrao-' + e,
                },
            });
            swiperPadrao.on('slideChangeTransitionEnd', function(sw){
                // console.log(swiperPadrao.activeIndex, sw);
                let imgZoom     = _tGal.find('.swiper-slide-active').find('.js-change-zoom').attr('data-zoom');
                let textDinamic = _tGal.find('.swiper-slide-active').find('img').attr('data-to-text');
                
                if(imgZoom)
                    _parent.find('.js-load-img-zoom').attr('href', imgZoom);

                if(textDinamic)
                    _parent.find('.js-dinamic-text').text(textDinamic);

            })
        })
    }

    //galeria horiz overflow
    const galleryHorz = () => {

        const galHoriz = "#swiper-horiz";
        if($(galHoriz).length <= 0) return;

        const swiperHoriz = new Swiper(galHoriz, {
            // cssMode     : true,
            speed       : 1500,
            loop        : false,
            effect      : 'slide',
            autoplay    : false,
            slidesPerView: "auto",//
            spaceBetween: 30,
            pagination  : {
                el: '#swiper-pagination-horiz',
                type : 'custom',
                renderCustom: function (swiper, current, total) {
                    return '<span class="swiper-pagination-current-custom">'+current + '</span> | ' + total;
                  }
                /* clickable: true,
                renderBullet: function (index, className) {
                  return '<span class="' + className + '">' + (index + 1) + "</span>";
                }, */
              },
              navigation: {
                  prevEl: "#swiper-horiz-button-prev",
                  nextEl: "#swiper-horiz-button-next",
              },
        });
    }

    const galleryProjetistas = () => {
        
        const galProjetista = ".swiper-projetistas";
        if($(galProjetista).length <= 0) return;
        console.log('usando');

        // for( let i=0; i< $(galProjetista).length; i++ ) {
        $(galProjetista).each(function(e) {

            $(galProjetista).eq(e).addClass('swiper-container-projetista-' + e);
            $(galProjetista).eq(e).closest('.row-gallery').find('.swiper-button-prev').addClass('swiper-button-prev-index-' + e);
            $(galProjetista).eq(e).closest('.row-gallery').find('.swiper-button-next').addClass('swiper-button-next-index-' + e);
            $(galProjetista).eq(e).closest('.row-gallery').find('.swiper-pagination').addClass('swiper-pagination-proj-index-' + e);

            const swiperProjetista = new Swiper('.swiper-container-projetista-' + e, {
                // cssMode     : true,
                speed       : 1500,
                loop        : false,
                effect      : $('.swiper-container-projetista-' + e).hasClass('type-slide') ? 'slide' : 'cube',
                autoplay    : false,
                slidesPerView : 1,
                // centeredSlides: true,
                spaceBetween: 30,
                pagination  : {
                    el: '.swiper-pagination-proj-index-' + e,
                    type : 'custom',
                    renderCustom: function (swiper, current, total) {
                        return '<span class="swiper-pagination-current-custom">'+current + '</span> | ' + total;
                    }
                    /* clickable: true,
                    renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "</span>";
                    }, */
                },
                navigation: {
                    prevEl: '.swiper-button-prev-index-' + e,
                    nextEl: '.swiper-button-next-index-' + e,
                },
                breakpoints : {
                    768: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                      },
                    1200: {
                        slidesPerView: 4,
                        slidesPerGroup: 4,
                      },
                }
            });
            swiperProjetista.on('slideChangeTransitionEnd', function(sw){
                // console.log(swiperPadrao.activeIndex, sw);
                let imgZoom     = $(galProjetista).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-zoom');
                let textDinamic = $(galProjetista).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-to-text');

                
                // ativa menu de nav
                const galTypeCurrent = $(galProjetista).eq(e).find('.swiper-slide-active').attr('data-img-gal');
                $('.wrap-menu-projetistas-mob a').removeClass('actived');
                $('.wrap-menu-projetistas-mob a[data-gal='+galTypeCurrent+']').addClass('actived');
                
                let _parent = $('.wrap-menu-projetistas-mob');
                
                //mobile change text
                const textDropMob = $('.wrap-menu-projetistas-mob a[data-gal='+galTypeCurrent+']').first().text(); 
                _parent.find('.dropdown-toggle').text('');
                _parent.find('.dropdown-toggle').text( textDropMob );
                
                
                if(imgZoom)
                    $(galProjetista).eq(e).closest('.row-gallery').find('.js-load-img-zoom').attr('href', imgZoom);

                if(textDinamic)
                    $(galProjetista).eq(e).closest('.row-gallery').find('.js-dinamic-text').text(textDinamic);

            })

            function getSlideIndexByClass(className) {
                var index = 0;
                $.each($(galProjetista).find('.swiper-wrapper').children(), function(i, item) {
                    if ($(item).hasClass(className)) {
                    index = i;
                    return false;
                    }
                });
                return index;
            }

            //navigation
            $(document).on('click', '.nav-type-gallery a', function(e){
                e.preventDefault();
                const _thisGalGo            = $(this);
                const typeGallery           = _thisGalGo.attr('data-gal');
    
                $('.wrap-menu-projetistas-mob a').removeClass('actived');
                _thisGalGo.addClass('actived');
                
                swiperProjetista.slideTo(getSlideIndexByClass('data-img-gal--'+typeGallery));
                
            })
        })
    }



    const galleryAptos = () => {

        const galAptos = ".swiper-aptos";
        

        // for( let i=0; i< $(galAptos).length; i++ ) {
        $(galAptos).each(function(e) {

            //if($(galAptos).eq(e).find('picture').length <= 1) return;

            let _parent = $(galAptos).eq(e).closest('.row-gallery');

            setTimeout(() => {
                getTextStart($(galAptos).eq(e).find('.swiper-slide-active'));
                _parent.find('.js-dinamic-plantas').addClass('motion-in')
            }, 500);

            $(galAptos).eq(e).addClass('swiper-container-aptos-' + e);
            _parent.find('.swiper-button-prev').addClass('swiper-button-prev-aptos-' + e);
            _parent.find('.swiper-button-next').addClass('swiper-button-next-aptos-' + e);
            _parent.find('.swiper-pagination').addClass('swiper-pagination-aptos-' + e);

            if($('.swiper-container-aptos-' + e).find('picture').length <= 1) {
                $('.swiper-container-aptos-' + e).closest('.row-gallery').find('.wrap-navigation-sw').hide();
            }

            const swiperAptos = new Swiper('.swiper-container-aptos-' + e, {
                // cssMode     : true,
                speed       : 1500,
                loop        : false,
                effect      : $('.swiper-container-aptos-' + e).hasClass('type-slide') ? 'slide' : 'cube',
                autoplay    : false,
                pagination  : {
                    el: '.swiper-pagination-aptos-' + e,
                    type : 'custom',
                    renderCustom: function (swiperAptos, current, total) {
                        return '<span class="swiper-pagination-current-custom">'+current + '</span> | ' + total;
                    }
                    /* clickable: true,
                    renderBullet: function (aptos, className) {
                    return '<span class="' + className + '">' + (aptos + 1) + "</span>";
                    }, */
                },
                navigation: {
                    prevEl: '.swiper-button-prev-aptos-' + e,
                    nextEl: '.swiper-button-next-aptos-' + e,
                },
            });
            swiperAptos.on('slideChangeTransitionEnd', function(sw){
                // console.log(swiperAptos.activeaptos, sw);
                let imgZoom     = $(galAptos).eq(e).find('.swiper-slide-active').find('.js-change-zoom').attr('data-zoom');
                _parent.find('.js-dinamic-plantas').removeClass('motion-in')
                setTimeout(() => {
                    getTextStart(_parent.find('.swiper-slide-active'));
                    _parent.find('.js-dinamic-plantas').addClass('motion-in')
                }, 500);

                
                if(imgZoom)
                    _parent.find('.js-load-img-zoom').attr('href', imgZoom);

                
            })
            
            function getTextStart(elm) {
                let textDinamic = elm.find('.gallery-content-diamic').html();
                if(textDinamic)
                    _parent.find('.js-dinamic-plantas').html(textDinamic);
            }
        })
    }


    return {

/*         init : () => {
            gallerySwiperWebdoor();
            // galleryBasicSwiper();
            // galleryHightlightsSwiper();
            // galleryDesignersSwiper();
        }
 */
        gallerySwiperWebdoor    : gallerySwiperWebdoor,
        galleryProject          : galleryProject,
        galleryLocation         : galleryLocation,
        galleryDiferenciais     : galleryDiferenciais,
        galleryPadrao           : galleryPadrao,
        galleryAptos            : galleryAptos,
        galleryProjetistas      : galleryProjetistas,
        galleryHorz             : galleryHorz,
        
        
    //    gallerySwiperWebdoor : gallerySwiperWebdoor()
        //teste : console.log('ufa')
    }

}();

export default SwiperGalleries;